
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { format, isValid } from 'date-fns';
import VueUtils from '@/../bower_components/teknisavuecomponents/assets/utils/VueUtils';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';

@Component({
  name: 'TkSelect',
  components: {
  },
})
export default class TkRange extends Vue{
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly dense: boolean;

  @Prop({ default: false })
  private readonly disabled: boolean;

  @Prop({ default: '' })
  private readonly label: string;

  @Prop({ default: false })
  private readonly month: string | boolean;

  @Prop({ default: false })
  private readonly readonly: boolean;

  @Prop({ default: true })
  private readonly showIcon: boolean;

  @Prop({ default: '' })
  private readonly value: string;
  // #endregion

  // #region [ DATA ]
  private showMenu = false;
  private date = '';
  private fieldDate = '';
  private activator: any = null;
  // #endregion

  // #region [ COMPUTED ]
  private get dateInYYYYMMDD(): string {
    if (this.date === '') {
      return '';
    }

    const date = DateUtil.formatToYYYYMMDD(this.date);

    return date;
  }

  private get icon(): string {
    const showIcon = VueUtils.propertyIsTrue(this.showIcon);
    const icon = showIcon ?
      'mdi-calendar' :
      undefined;

    return icon;
  }

  private get propMonth(): boolean {
    const month = VueUtils.propertyIsTrue(this.month);

    return month;
  }

  private get textReadOnly(): boolean {
    const readOnly = this.readonly || this.propMonth;

    return readOnly;
  }

  private get datePickerType(): string {
    const type = this.propMonth ?
      'month' :
      'date';

    return type;
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    const date = this.value || '';

    this.date = date;
    this.fieldDate = date;
  }
  // #endregion

  // #region [ METHODS ]
  private dateOnInput(unformattedDate: string) {
    let dateDMY;

    if (this.propMonth) {
      // Formats the YYYY-MM date to DD/MM/YYYY
      dateDMY = DateUtil.formatYYYYMMToDDMMYYYY(unformattedDate);
    } else {
      // Formats the YYYY-MM-DD date to DD/MM/YYYY
      dateDMY = DateUtil.formatToDDMMYYYY(unformattedDate);
    }

    this.date = dateDMY;
    this.fieldDate = dateDMY;

    this.showMenu = false;
    super.$emit('input', this.date);
  }

  private fieldOnInput(dateDMY: string) {
    // Completes the date string if it's incomplete ('01/2' => '01/02/currentYear')
    const adjustedDate = DateUtil.formatDate(dateDMY);

    this.fieldDate = dateDMY;
    this.date = adjustedDate;

    const fieldDateIsValid = this.fieldDate === adjustedDate;

    if (fieldDateIsValid) {
      super.$emit('input', this.date);
    }
  }

  private fieldOnTab() {
    this.showMenu = false;
    super.$emit('input', this.date);
  }
  // #endregion
}
